export enum FILE_PICKER_MODES {
    IMAGE = 'image',
    VIDEO = 'video',
    AUDIO = 'audio',
    DOCUMENT = 'document',
    GIF = 'gif',
}

export type FILE_PICKER_MODE = `${FILE_PICKER_MODES}`
